<div class="d-flex justify-content-center gap-2 flex-column flex-sm-row align-items-center">
  <span [attr.id]="'paginierung-termine-treffervonbis_' + angebotId" class="align-self-center"
    >{{ ersterTreffer | number }}-{{ letzterTreffer | number }} von {{ totalItems }}</span
  >
  <now-wbsuche-lib-pagination-dpl
    [attr.id]="'paginierung-termine_' + angebotId"
    [anzahlTreffer]="totalItems"
    [aktuelleSeite]="currentPage"
    [anzahlSeiten]="anzahlSeiten"
    [position]="'unten'"
    [idSuffix]="'termin_' + angebotId"
    (firstClicked)="pageFirstClicked()"
    (prevClicked)="pagePrevClicked()"
    (nextClicked)="pageNextClicked()"
    (lastClicked)="pageLastClicked()"
    (threePagesPreviousClicked)="threePagesBackwards()"
    (threePagesNextClicked)="threePagesForwards()"
  ></now-wbsuche-lib-pagination-dpl>
</div>
